<template>
  <div class="sa-card sa-card-border sa-card-noshadow">
    <avtar :editBoolean="editBoolean" @editFlag="pflag =$event" @imgEvent="imgUrl =$event" />
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="sa-tit-heading sa-h-sm-up">Education & Training</div>
      <form @submit.prevent>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg4">
          <ValidationProvider rules="required" tag="div" class="sa-form-group" v-slot="{errors}" name="degree">
            <label>
              Degree
              <span class="sa-red-text">*</span>
            </label>
            <!-- <input @input="educationDetails.deg = educationDetails.deg.split(',')" v-model="educationDetails.deg" type="text" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/> -->
            <v-select
              :options="degreeList"
              class="sa-multiple-tag"
              multiple
              label="name"
              :reduce="d=>d.deg_id"
              v-model="educationDetails.education.deg"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''" name="degree" id="degree"
            ><span slot="no-options">No data</span></v-select>
          <span class="sa-val-err">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div v-if="pInfo.personal.utid == '1'" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Medical School</label>
            <!-- <input @input="educationDetails.sch = educationDetails.sch.split(',')" v-model="educationDetails.sch" type="text" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/> -->
            <v-select
              :options="educationDetails.education.medical_school"
              v-model="educationDetails.education.medical_school"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''" id="medicalSchool" name="medical School"
            ><span slot="no-options">No data</span></v-select>
          </div>
        </div>
        <div v-if="pflag && pInfo.personal.utid == '1'" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Medical School(Arabic)</label>
            <!-- <input @input="educationDetails.sch = educationDetails.sch.split(',')" v-model="educationDetails.sch" type="text" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/> -->
            <v-select
              :options="educationDetails.education.medical_school_ar"
              v-model="educationDetails.education.medical_school_ar"
              taggable
              multiple
              class="sa-multiple-tag" id="medicalSchoolAr" name="medicalSchoolAr"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
          </div>
        </div>
      </div>
      <!-- <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Membership</label>
            <v-select
              :options="educationDetails.education.memship"
              v-model="educationDetails.education.memship"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
          </div>
        </div>
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Membership(Arabic)</label>
            <v-select
              :options="educationDetails.education.memship_ar"
              v-model="educationDetails.education.memship_ar"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''" 
            ><span slot="no-options">No data</span>
  </v-select>
          </div>
        </div>
      </div> -->
      <!-- <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Specialized In</label>
            <v-select
              :options="educationDetails.education.special_in"
              v-model="educationDetails.education.special_in"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            > 
            <span slot="no-options">No data</span>
            </v-select>
             <v-select :options="selectmedintship" v-model="pInfo.intship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select>
          </div>
        </div>
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Specialized In (Arabic)</label>
            <v-select
              :options="educationDetails.education.special_in_ar"
              v-model="educationDetails.education.special_in_ar"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
             <v-select :options="selectmedintship" v-model="pInfo.intship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select>
          </div>
        </div>
      </div> -->
      <div v-if="pInfo.personal.utid == '1'" class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Internship</label>
            <v-select
              :options="educationDetails.education.intship"
              v-model="educationDetails.education.intship"
              taggable
              multiple
              class="sa-multiple-tag" id="internship" name="Internship"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
            <!-- <v-select :options="selectmedintship" v-model="pInfo.intship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
          </div>
        </div>
        <div v-if="pflag && pInfo.personal.utid == '1'" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Internship (Arabic)</label>
            <v-select
              :options="educationDetails.education.intship_ar"
              v-model="educationDetails.education.intship_ar"
              taggable
              multiple id="internshipAr" name="internshipAr"
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
            <!-- <v-select :options="selectmedintship" v-model="pInfo.intship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
          </div>
        </div>
      </div>
      <div v-if="pInfo.personal.utid == '1'" class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Fellowship</label>
            <v-select
              :options="educationDetails.education.felship"
              v-model="educationDetails.education.felship"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag" id="fellowship" name="Fellowship"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
            <!-- <v-select :options="selectfelloship" v-model="pInfo.felship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
          </div>
        </div>
        <div v-if="pflag && pInfo.personal.utid == '1'" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Fellowship(Arabic)</label>
            <v-select
              :options="educationDetails.education.felship_ar"
              v-model="educationDetails.education.felship_ar"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''" id="fellowshipAr" name="fellowshipAr"
            ><span slot="no-options">No data</span></v-select>
            <!-- <v-select :options="selectfelloship" v-model="pInfo.felship" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select> -->
          </div>
        </div>
      </div>
      <div v-if="pflag" class="sa-text-right">
        <button class="sa-btn sa-btn-primary sa-btn-block-xs" @click="handleSubmit(updateProfile)">
          Save
        </button>
      </div>
    </form>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";
import { pro_url } from "../../../config/endpoints";
import { oh_url, com_url } from "../../../config/endpoints";
export default {
  props: ["pInfo"],
  components: {
    avtar: AvtarVue,
  },
  data() {
    return {
      imgUrl: null,
      degreeList: [],
      editBoolean: false,
      pflag: false,
      loader: false,
      img: "",
      selectdegree: [],
      selectmedsch: [],
      selectmedintship: [],
      selectfelloship: [],
      educationDetails: {
        mtype: "education",
        education: {
          img: "",
          deg: ["DEG15", "DEG16"],
          medical_school: ["medical_school"],
          medical_school_ar: ["medical_school_ar"],
          memship: ["memship"],
          memship_ar: ["memship_ar"],
          special_in: ["special_in"],
          special_in_ar: ["special_in_ar"],
          felship: ["felship"],
          felship_ar: ["felship_ar"],
          intship: ["intship"],
          intship_ar: ["intship_ar"],
          res: ["res"],
          res_ar: ["res arabic"],
        },
      },
    };
  },
  methods: {
    getStaticData() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: {
            mtype: ["deg"],
            utid: "1",
          },
        })
        .then((response) => {
          if (response.status = 1000) {
            _self.degreeList = response.data.degree;
          }
        })
        .catch((e) => {
         // console.log(e);
        });
    },
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
    },
    setProfileData() {
      let _self = this;
      _self.educationDetails.education = _self.pInfo.education;
    },
    updateProfile(obj, params) {
      let _self = this;
      _self.loader = true;
      //   _self.educationDetails.sch = _self.educationDetails.sch.filter(
      //     (e) => e.trim() != ""
      //   );
      //   _self.educationDetails.intship = _self.educationDetails.intship.filter(
      //     (e) => e.trim() != ""
      //   );
      //   _self.educationDetails.felship = _self.educationDetails.felship.filter(
      //     (e) => e.trim() != ""
      //   );
      //   _self.educationDetails.memship = _self.educationDetails.memship.filter(
      //     (e) => e.trim() != ""
      //   );
      if (_self.imgUrl) {
          _self.educationDetails.education.img = _self.imgUrl
        let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
        userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(userInfo),
          60 * 60 * 2 + 55
        );
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.educationDetails,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$parent.getUserData()
            // console.log('profile updated')
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Education & Training updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            // console.log('Error in edit profile data')
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
    saveProfile() {
      let _self = this;
      let p = _self.pInfo;
      if (_self.img) {
        p.img = _self.img;
      }
      _self.$parent.updateProfile(p);
    },
  },
  mounted() {
    this.getStaticData();
    this.setProfileData();
   // this.$refs.select.open = false
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
  },
};
</script>
